import React from 'react';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { StandardField, UserAttribute, TbitIntegration } from './types';
import LeftPanel from './LeftPanel';

interface MobileFieldsModalProps {
  isOpen: boolean;
  onClose: () => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  expandedSections: {
    standardFields: boolean;
    contactInfo: boolean;
    tbitIntegrations: boolean;
  };
  toggleSection: (section: 'standardFields' | 'contactInfo' | 'tbitIntegrations') => void;
  agentId?: string;
  onFieldClick: (field: StandardField | UserAttribute | TbitIntegration) => void;
}

const MobileFieldsModal: React.FC<MobileFieldsModalProps> = ({
  isOpen,
  onClose,
  searchTerm,
  setSearchTerm,
  expandedSections,
  toggleSection,
  agentId,
  onFieldClick
}) => {
  const { t } = useTranslation('forms');

  const handleFieldClick = (field: StandardField | UserAttribute | TbitIntegration) => {
    onFieldClick(field);
    onClose(); // Cerrar el modal después de seleccionar un campo
  };

  if (!isOpen) return null;

  return (
    <div className="modal modal-open lg:hidden">
      <div className="modal-box w-11/12 max-w-md h-5/6 p-0 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white sticky top-0 z-10">
          <h3 className="text-lg font-semibold text-gray-900">
            {t('add_fields', 'Agregar Campos')}
          </h3>
          <button
            onClick={onClose}
            className="btn btn-sm btn-circle btn-ghost"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Content - LeftPanel sin padding externo */}
        <div className="h-full overflow-y-auto">
          <div className="w-full">
            <LeftPanel
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              agentId={agentId}
              onFieldClick={handleFieldClick}
            />
          </div>
        </div>
      </div>
      
      {/* Backdrop */}
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default MobileFieldsModal;
